/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Origin_UnknownInputs */

const en_us2_plan_origin_unknown = /** @type {(inputs: Plan_Origin_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not tell who created this plan.`)
};

const pt_br2_plan_origin_unknown = /** @type {(inputs: Plan_Origin_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não conseguimos saber quem criou este plano.`)
};

const es_419_plan_origin_unknown = /** @type {(inputs: Plan_Origin_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos saber quién creó este plan.`)
};

const pt_pt2_plan_origin_unknown = /** @type {(inputs: Plan_Origin_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não conseguimos saber quem criou este plano.`)
};

const fr_fr2_plan_origin_unknown = /** @type {(inputs: Plan_Origin_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de savoir qui a créé ce programme.`)
};

const de_de2_plan_origin_unknown = /** @type {(inputs: Plan_Origin_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir konnten nicht feststellen, wer diesen Plan erstellt hat.`)
};

const it_it2_plan_origin_unknown = /** @type {(inputs: Plan_Origin_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non siamo riusciti a capire chi ha creato questa scheda.`)
};

/**
* | output |
* | --- |
* | "We could not tell who created this plan." |
*
* @param {Plan_Origin_UnknownInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_origin_unknown = /** @type {((inputs?: Plan_Origin_UnknownInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Origin_UnknownInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_origin_unknown(inputs)
	if (locale === "es-419") return es_419_plan_origin_unknown(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_origin_unknown(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_origin_unknown(inputs)
	if (locale === "de-DE") return de_de2_plan_origin_unknown(inputs)
	if (locale === "it-IT") return it_it2_plan_origin_unknown(inputs)
	return en_us2_plan_origin_unknown(inputs)
});
export { plan_origin_unknown as "plan.origin_unknown" }